import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ActionArea from '../../components/ActionArea'
import SelectInput from '../../components/UI/SelectInputGameDef'
import SmartSearch from '../../components/UI/SmartSearch'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getDecksList, getDeckToCopy, getGamesList, updateDecksList } from '../../services/decksManagement'
import { notificationError } from '../../services/notification'
import { getPermission } from '../../services/permisssion'
import { Modal, Table, Tag } from 'antd';
import {
  IContentGames,
  IDecksChanges,
  IDecksList,
  IDecksListRows,
  ITableCheckboxProps,
  ITableRows,
  ITopGames
} from './types'
import { ChangesModalContent, DecksChanges, getColConfig, getInputBackgroundColor, getTagBackGroundColor, useDataTransform } from './useDecksManagement'
import { numberToCurrency } from '../../utils/objectUtils'
import FloatingButton from '../../components/UI/FloatingButton'
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth'
import { ColumnsType } from 'antd/lib/table'
import { ISelectOption } from '../../components/UI/SelectInput/types'
import { stringCompare } from '../../utils/sorters'
import { onlyNumbers } from '../../utils/formValidation'

let games:{name:string, value:number}[] = [];
let headerFormNames: string[] = [];

function index(props: {accessLevel: string}) {
  const loading = useLoading()
  const {canEdit} = useAuth()
  const log = {
    log_type: 'visited',
    log_object: 'decks_management'
  }
  const [gameOptions, setGameOptions] = useState<ISelectOption[]>([])
  const [headers, setHeaders] = useState<string[]>([]);
  const [topGames, setTopGames] = useState<ITopGames[]>([]);
  const [validSearch, setValidSearch] = useState(false)
  const [initialized, setInitialized] = useState(true)
  const [form, setForm] = useState({
    search: '',
    game: '',
  })
  const [smartSearch, setSmartSearch] = useState({
    type: '',
    id: '',
    name: '',
  })
  const [lastSearch, setLastSearch] = useState({
    type: '',
    id: '',
    name: '',
  })
  const [decksList, setDecksList] = useState<IDecksListRows[]>([])
  const [changed, setChanged] = useState<IDecksChanges[]>([])
  const [gameCopy, setGameCopy] = useState({
    from: '',
    to: ''
  })
  
  useEffect(() => {
    sendSystemLog(log);
  }, [])

  const onChange = (e: React.ChangeEvent<HTMLInputElement>, wager: IDecksChanges, defaultValue: boolean, wagerAmt: number) => {
    //duplicate existing changes
    let changedCopy = changed
    //Don't allow changes to disabled controls
    if(e.target.disabled) return

    let gameGroup : string | null = null
    //Find game group
    topGames.forEach(function(game, index) {
      if (game.gameId===wager.gameId){
        gameGroup = game.gameGroup
      }
    })

    //Loop through wagers
    topGames.forEach(function(game, index){
      let duplicatedIndex = -1
      if ((gameGroup && gameGroup===game.gameGroup) || (!gameGroup && game.gameId===wager.gameId)) {
        //create new wager object
        let newWager: IDecksChanges = {locationId: wager.locationId, gameId: game.gameId}
        //Find out if entry already exists
        changed.find(({gameId, locationId}, index) => {
          if (gameId === newWager.gameId && locationId === newWager.locationId) {
            duplicatedIndex = index
            return true
          }
          return false
        })

        const duplicatedFound = duplicatedIndex !== -1
        //remove duplicate from list
        if (duplicatedFound) changedCopy.splice(duplicatedIndex, 1)
        //save list with item removed because it is back to starting status
        if (!(duplicatedFound && e.target.checked === defaultValue)) {
          //Add new item
          newWager.enabled=e.target.checked;
          changedCopy.push(newWager)
        }
      }
    })
    setChanged([...changedCopy])
  }

  const sameGameGroup = (firstForm: string | undefined, secondForm: string | undefined) : boolean => {
    if (firstForm===secondForm) return true;

    let gameGroup: string | null = null

    topGames.forEach(function(game, index) {
      if (game.form===firstForm){
        gameGroup = game.gameGroup
      }
    })
    let found = false;
    if (gameGroup) {
      topGames.forEach(function (game, index) {
        if (game.form === secondForm) {
          found = game.gameGroup === gameGroup;
        }
      })
    }

    return found;
  }

  const checkAll = (e: ChangeEvent<HTMLInputElement>, columnIdentifier?: string) => {
    const checkboxes: NodeListOf<HTMLInputElement & {type: 'checkbox'}> = document.querySelectorAll(`input[type=checkbox]`)
    const changedCopy = changed
    checkboxes.forEach((checkbox) => {

      //Get out if the checkbox does not exist or is disabled.
      if(!checkbox || checkbox.disabled) return
      //Get out if the checkbox did not change
      if(checkbox.checked === e.target.checked) return
      //get out if you clicked a column and the checkbox does not match the column.
      if(columnIdentifier && columnIdentifier !== checkbox.dataset.form) return
      const isLikeDefaultValue = e.target.checked === checkbox.defaultChecked
      const location = checkbox.dataset.location &&  parseInt(checkbox.dataset.location)
      const game = checkbox.dataset.game && parseInt(checkbox.dataset.game)

      checkbox.checked = e.target.checked

      if(!game || !location) return 

      //loop through game defs
      let count = 0;
      topGames.forEach(function(topGame, index) {
        if (sameGameGroup(checkbox.dataset.form, topGame.form)) {
          if (isLikeDefaultValue) {
            const indexFound = changedCopy.findIndex(({locationId, gameId}) => locationId === location && gameId === topGame.gameId)
            if (indexFound !== -1) changedCopy.splice(indexFound, 1)
          } else {
            changedCopy.push({
              locationId: location,
              gameId: topGame.gameId,
              enabled: e.target.checked
            })
          }
        }
      })

    })

    setChanged([...changedCopy])
  }

  const getViariants = (actualForm: string, contentGamesList: IContentGames[], actualIndex: number): {nameList: string, variants: IContentGames[]} | void => {
    const variants = contentGamesList.filter((games) => onlyNumbers(games.form) === onlyNumbers(actualForm))
    const nameList = variants.map((game) => game.form).join("\n ")
    if(headerFormNames.find((name) => name === nameList)) return 
    headerFormNames.push(nameList)
    return {nameList, variants}
  }
  
  const getCols = () => {
    if(!decksList || decksList.length === 0) return []

    let cols: any  = []

    Object.keys(decksList[0].itemContentLocationDTO).forEach((key) => {
      if(key === 'locationId' || key === 'disableDeckManagement') return
      const config = getColConfig(key, headers)
      if(key !== 'wagers') {
        cols.push({
          title: config.key ,
          dataIndex: key,
          fixed: config.fixed,
          width: config.width,
          sorter: (a: ITableRows, b: ITableRows) => config.sorter(a, b),
          render: (val: string, row: ITableRows) => ( 
            <Tag 
              className="decks-management__text-tag" 
              {...getTagBackGroundColor(row.countOldVersion > 0, row.disableDeckManagement)}
            >
              {val}
            </Tag>
          )
        })
      }
    })

    const childreenWager:any  = []
    headerFormNames = []
    decksList[0].contentGames.forEach((wager: IContentGames, index: number) => {
      const firstVariant = getViariants(wager.form, decksList[0].contentGames, index)
      if(!firstVariant) return
      const {nameList, variants} = firstVariant
      childreenWager.push({
        title: (
          <div style={{color: wager.official ? '' : 'red'}}>
            <input  className="decks-management__checkbox" type="checkbox" onChange={(e) => checkAll(e, wager.form)} disabled={!canEdit} />
            <br/> 
            {numberToCurrency(wager.wager)}
            <br/> 
            {nameList}    
          </div>
        ),
        dataIndex: wager.form,
        width: 100,
        render: (val: ITableCheckboxProps, row: IContentGames) => (
          <Tag {...getInputBackgroundColor(row.locationId, val.gameId, changed)} key={row.gameId + row.locationId}>
            {variants.map((variant, i) => (
              <input
                style={{display: i === 0 ? '': 'none', margin: 'auto'}} 
                className="decks-management__checkbox"
                type="checkbox"
                disabled={row.disableDeckManagement || !canEdit}
                data-wager={wager.wager}
                data-location={row.locationId}
                data-game={val.gameId}
                data-form={variant.form}
                id={`${val.gameId}_${row.locationId}_${wager.wager}_${i}`}
                defaultChecked={val.enabled}
                onChange={(e) => i === 0 && onChange(
                  e,
                  {locationId: row.locationId, gameId: val.gameId},
                  val.enabled,
                  variant.wager
                )}
              />
            ))}
          </Tag>
        )
      })
    })
    cols.push({
      title: <div><label htmlFor="selectall" ><input id="selectall" className="decks-management__checkbox" type="checkbox" onChange={checkAll}/> Select All</label></div>,
      children: childreenWager
    })
    return cols
  }
  const initialize = async() => {
    games = await getGamesList()

    if(games && games.length > 0) {
      setGameOptions(games.map((game) => ({name: game.name, value: game.name})))
      setForm({...form, game: games[0].name})
      setGameCopy({...gameCopy, from: games[0].name})
    } 
  }
  useEffect(() => {
    loading.addLoading()
    initialize()
    loading.removeLoading()
  },[])

  //useEffect(() => {
  //  console.log(changed)
  //},[changed])

  useEffect(() => {
    console.log(form)
  },[form])

  const onSubmit = async () => {
    loading.addLoading()
    let changedToSend: IDecksChanges[][] = []
    let locationFound: number[] = []
    changed.forEach(( change )=> {
      if(locationFound.find((a) => a === change.locationId)) return 
      locationFound.push(change.locationId)

      const changesByLocationId = changed.filter(({locationId}) => locationId === change.locationId)
      changedToSend = [...changedToSend, changesByLocationId]
    })

    const payload = {
      companyType: lastSearch.type,
      companyId: lastSearch.id,
      companyName: lastSearch.name,
      listLocations: changedToSend
    }
    const successResponse = await updateDecksList(payload)
    new Promise(res => setTimeout(res => onRefresh(), 1000));
    loading.removeLoading()
    if(!successResponse) return 
    setInitialized(false)
    setChanged([])
    const modalChanges: DecksChanges[] = [];
    let prevLocationId = 0
    let prevLocationName = ''
    payload.listLocations.forEach((locationChange) => {
      locationChange.forEach((change) => {
        const status = 'SUCCESS';
        let location = ''
        let form = ''
        const action = change.enabled ? 'ENABLE' : 'DISABLE'
        
        if(prevLocationId === change.locationId) {
          location = prevLocationName
        } else {
          decksList.forEach((deck) => {
            if(deck.itemContentLocationDTO.locationId === change.locationId) {
              location = deck.itemContentLocationDTO.locationName
            }
            const findForm = deck.contentGames.find((value) => value.locationId === change.locationId && value.gameId === change.gameId)
            if(findForm) form = findForm.form
          })
        }
        
        
        modalChanges.push({
          status,
          location,
          form,
          action
        })
      })
    })

    Modal.success({
      title: 'Finished',
      content: <ChangesModalContent changes={modalChanges} />,
      onOk: () => {},
      width: '50vw',
      cancelText: 'Close',
    })
  }

  const onRefresh = async () => {
    loading.addLoading()
    console.log(`Game = ${form.game}`)
    const params = {
      game: form.game,
      [smartSearch.type + 'Id']: smartSearch.id
    }
    const decks = await getDecksList(params)
    loading.removeLoading()
    setChanged([])
    setInitialized(false)
    setLastSearch(smartSearch)
    if(decks.rows.length === 0) return
    setGameCopy({...gameCopy, to: form.game})
    setDecksList([...decks.rows])
    setHeaders(decks.topLocation)
    setTopGames(decks.topGame)
  }

  useEffect(() => {
    if(!initialized) setInitialized(true)
  }, [initialized])
  
  const onCopyGame = async () => {

    const game = games.find((game) => game.name === gameCopy.from)
    if(!game)return console.log(gameCopy.from)
    loading.addLoading()

    const locations = decksList.map((row) => row.itemContentLocationDTO.locationId)
    if(!locations || locations.length === 0) {
      loading.removeLoading()
      return
    }
    const decksToCopy = await getDeckToCopy({game: game.name, [`${smartSearch.type}Id`]: smartSearch.id})
    let copyChanges:IDecksChanges[] = []

    decksToCopy.forEach((deck) => {
      const { locationId } = deck.itemContentLocationDTO
      deck.contentGames.map((game)=> {
        const {wager, enabled} = game
        const stateChange = changeCheckboxState(locationId, wager, enabled)
        if(stateChange) copyChanges = [...copyChanges, ...stateChange]
      })
    })
    setChanged([...changed, ...copyChanges])
    loading.removeLoading()
  }

  const changeCheckboxState = (locationId: number, wager: string, enabled: boolean): IDecksChanges[] | undefined => {
    const checkbox: NodeListOf<HTMLInputElement & { type: "checkbox" }>  = document.querySelectorAll(`[data-location="${locationId}"`)
    const itemsToReturn: IDecksChanges[] = []
    if(!checkbox || !enabled) return
    checkbox.forEach((check) => {
      if(!(check.dataset.wager !== wager || check.disabled || !check.id.endsWith("_0"))) {
        //only change the contents if not matching
        if (check.checked!==enabled) {
          check.checked = enabled
          //loop through games to find ones with same gameGroup
          topGames.forEach(function (game, index) {
            if (sameGameGroup(check.dataset.form, game.form)) {
              itemsToReturn.push({gameId: game.gameId, locationId, enabled})
            }
          })
        }
      }
    })

    return itemsToReturn
  }

  return (
    <div className="decks-management">
      <ActionArea buttonAction={onRefresh} buttonText={'Search'} disabled={!validSearch}>
        <>
          <SelectInput
            label="Game to Configure"
            options={gameOptions}
            value={form.game || gameOptions[0]?.value}
            onSelectChange={(e) => setForm({...form, game: e.value?e.value:e})}
            autoFocus
          />
          <SmartSearch
            value={form.search}
            onChange={(e: string) => setForm({...form, search: e})}
            onValidSearch={setValidSearch}
            label='Smart Search'
            status="active"
            searchBy={['distributor', 'charity', 'location']}
            onObjValueChange={(e) => setSmartSearch(e)}
          />
        </>
      </ActionArea>
      {decksList.length > 0 && initialized && (
        <div>
          <h2 className='decks-management__title'>{gameCopy.to}</h2>
          <ActionArea buttonAction={() => onCopyGame()} buttonText={'Apply to the screen'} disabled={!canEdit}>
            <>
              <SelectInput
                label="Copy"
                options={gameOptions}
                value={gameCopy.from || gameOptions[0]?.value}
                onSelectChange={(e) => setGameCopy({...gameCopy, from: e.value?e.value:e})}
                disabled={!canEdit}
              />
              <p className="decks-management__config-to">configuration to {gameCopy.to}</p>
            </>
          </ActionArea>
          <div className="decks-management__colors">
            <Tag color="red">
              Changes not saved
            </Tag>
            <Tag color="orange">
              Has older versions
            </Tag>
            <Tag color="gray">
              Not allowed to edit	
            </Tag>
          </div>
          <Table
            className="decks-management__table"
            scroll={{x: '1330'}}
            pagination={false}
            columns={getCols()}
            dataSource={useDataTransform(decksList)}
          />
          <FloatingButton text="Save Changes" onClick={()=> onSubmit()} disabled={(changed.length === 0) || !canEdit}/>
        </div>
      )}
    </div>
  )
}

export default index


